import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {},
    input: {
      fontWeight: 100,
    },
    submit: {
      width: '100%',
    },
  },
  {
    name: 'UsernameForm',
  },
);
